import { flow } from 'fp-ts/function';
import { getItemByCommonPropertyValue } from '@mews/fp';
import { getCheckedReservations } from '../../../selectors';

export const getReleaseFormInitialValues = flow(
    getCheckedReservations,
    getItemByCommonPropertyValue('releasedUtc'),
    (releasedUtc) => ({ releasedUtc })
);
